module.exports = __webpack_public_path__ + "static/img/bc-hmls.9934571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-hmls.png
// module id = Xia3
// module chunks = 0